import React from "react";

//Creates a diagonal line across its children
//TODO: Figure out a way to do this automatically based on height, width, padding of container so developer does not have to hard code as many props
export const Strikethrough = ({
  children,
  strokeWidth = 2,
  widthAdd,
  color = "black",
  padding,
  rotation,
  containerStyle,
  containerClass,
  flip,
}) => {
  return (
    <div
      style={{
        position: "relative",
        width: "fit-content",
        // backgroundColor: "blue", // for debugging
        ...containerStyle,
      }}
      className={containerClass}
    >
      <div
        style={{
          position: "absolute",
          backgroundColor: color,
          height: `${strokeWidth}px`,
          left: 0 - widthAdd,
          right: 0 - widthAdd,
          ...(flip ? { bottom: 0 } : { top: 0 }),
          transform: `rotate(${flip ? -1 * rotation : rotation}deg)`,
          transformOrigin: "top left",
        }}
      ></div>
      {children}
    </div>
  );
};
